<template>
    <div class="pro-report">
       <div class="u-time" >
         <van-icon name="arrow-left" @click="lf()" />
         <div class="date" @click="show = true;">{{this.reportDate}}</div>
         <van-icon name="arrow" @click="rg()"/>
       </div>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker show-toolbar title="选择时间" v-model="currentDate" type="year-month" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
       <van-tabs v-model="active">
            <van-tab title="人员结构">
                <ul class="detail">
                    <li>
                        <div class="num">{{orgMap.amoutSum}}</div>
                        <div class="name">{{thisMonth}}月在职</div>
                        <i class="line"></i>
                    </li>
                    <li>
                        <div class="num">{{orgMap.avgLeave}}</div>
                        <div class="name">离职率</div>
                        <i class="line"></i>
                    </li>
                    <li>
                        <div class="num">{{orgMap.avgEntry}}</div>
                        <div class="name">入职率</div>
                        <i class="line"></i>
                    </li>
                </ul>
                <!-- <van-collapse v-model="activeNames" >
                  <van-collapse-item class="u-card u-card2" :name=index v-for="(item,index) in xyDetail" :key="item.id">
                    <template #title>
                      <div class="hd">
                      <span class="name">{{item.plate}}</span>
                      <div>
                        <div>明细</div>
                         <div>趋势</div> 
                      </div>
                    </div>
                    </template>
                    <ul class="list" v-if="item.detail.length > 0">
                      <li>
                        <div class="item">单位</div>
                        <div class="item2 line">5月人数</div>
                        <div class="item2 back">6月人数</div>
                        <div class="item3 back">入职</div>
                        <div class="item3 back">离职</div>
                        <div class="item3 back">调入</div>
                        <div class="item3 back">调出</div>
                      </li>
                      <li  v-for="childItem in item.detail" :key="childItem.id">
                        <div class="item">{{childItem.ORGANIZATION}}</div>
                        <div class="item2 line">{{childItem.LASTMONTH}}</div>
                        <div class="item2 back">{{childItem.NOWMONTH}}</div>
                        <div class="item3 back">{{childItem.ENTRY}}</div>
                        <div class="item3 back">{{childItem.LEAVE}}</div>
                        <div class="item3 back">{{childItem.CALLIN}}</div>
                        <div class="item3 back">{{childItem.RECALL}}</div>
                      </li>
                      
                    </ul>
                    <div class="empty" v-else>
                        本报表生成时，{{item.plate}}暂未发放薪资
                      </div>
                  </van-collapse-item>
                  
                </van-collapse> -->
                <div class="u-card u-card2"  v-for="(item,index) in xyDetail" :key="item.id">
                    <div class="hd">
                      <div class="name">{{item.plate}}<span class="exp" v-if="!item.isdetail">近6个月统计</span></div>
                      <div class="isdetail" @click="isChart(index)">
                        <div class="f-dfa" v-if="item.isdetail"><i class="mx"></i> 明细</div>
                        <div class="f-dfa" v-else><i class="qs"></i>趋势</div>
                      </div>
                    </div>
                    <ul class="list" v-if="item.isdetail">
                      <li>
                        <div class="item">单位</div>
                        <!-- <div class="item2 line">5月人数</div> -->
                        <div class="item2 back">{{thisMonth}}月人数</div>
                        <div class="item3 back">入职</div>
                        <div class="item3 back">离职</div>
                        <div class="item3 back">调入</div>
                        <div class="item3 back">调出</div>
                      </li>
                      <li  v-for="childItem in item.detail" :key="childItem.id">
                        <div class="item">{{childItem.ORGANIZATION}}</div>
                        <!-- <div class="item2 line">{{childItem.LASTMONTH}}</div> -->
                        <div class="item2 back">{{childItem.NOWMONTH}}</div>
                        <div class="item3 back">{{childItem.ENTRY}}</div>
                        <div class="item3 back">{{childItem.LEAVE}}</div>
                        <div class="item3 back">
                          <div class="jx">
                          {{childItem.CALLIN}}<i v-if="childItem.ORGANIZATION == '设计研究院' || childItem.ORGANIZATION == '苏州澳洋生态'|| childItem.ORGANIZATION == '北京分公司'|| childItem.ORGANIZATION == '云南分公司'|| childItem.ORGANIZATION == '华东分公司'|| childItem.ORGANIZATION == '连云港物业'" class="star">*</i>
                          </div>
                        </div>
                        <div class="item3 back">
                          <div class="jx">
                          {{childItem.RECALL}}<i v-if="childItem.ORGANIZATION == '设计研究院' || childItem.ORGANIZATION == '苏州澳洋生态'|| childItem.ORGANIZATION == '北京分公司'|| childItem.ORGANIZATION == '云南分公司'|| childItem.ORGANIZATION == '华东分公司'|| childItem.ORGANIZATION == '连云港物业'" class="star">*</i>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="item">合计</div>
                        <!-- <div class="item2 line">{{childItem.LASTMONTH}}</div> -->
                        <div class="item2 back">{{item.sumMap.nowAmoutSum}}</div>
                        <div class="item3 back">{{item.sumMap.entrySum}}</div>
                        <div class="item3 back">{{item.sumMap.leaveSum}}</div>
                        <div class="item3 back">{{item.sumMap.callInSum}}</div>
                        <div class="item3 back">{{item.sumMap.recallSum}}</div>
                      </li>
                    </ul>
                    <div v-else>
                        <div class="chart" :id=item.idname :style="{ height: '184px'}"></div>
                        <!-- <div id="chart_0" :style="{ height: '200px'}"></div> -->
                    </div>
                  </div>
                  
                <div>
                  <ul class="exp">
                    <li>*HR中为生态园林、澳洋物业下级部门，无法作为公司统计调入、调出数据；</li>
                  </ul>
                </div>
            </van-tab>
            <van-tab title="薪资发放">
                <ul class="detail" >
                    <li>
                        <div class="num">{{salary.all.bePaySum}}W</div>
                        <div class="name">{{thisMonth}}月应发</div>
                        <i class="line"></i>
                    </li>
                    <li>
                        <div class="num">{{salary.all.paySum}}W</div>
                        <div class="name">{{thisMonth}}月实发</div>
                        <i class="line"></i>
                    </li>
                    <li>
                        <div class="num">{{salary.all.avgSum}}W</div>
                        <div class="name">人均工资</div>
                        <i class="line"></i>
                    </li>
                </ul>
                <div>
                  <div class="u-card"  v-for="item in salary.detail" :key="item.id">
                    <div class="hd">
                      <span class="name">{{item.plate}}</span>
                      <span>工资单位：万(W)</span>
                    </div>
                    <ul class="list" v-if="item.detail.length > 0">
                      <li>
                        <div class="item">单位</div>
                        <div class="item2 line">发放人数</div>
                        <div class="item2 back">应发总额</div>
                        <div class="item3 back">实发</div>
                        <div class="item2 back">绩效奖</div>
                        <div class="item2 back">人均工资</div>
                      </li>
                      <li  v-for="childItem in item.detail" :key="childItem.id">
                        <div class="item">{{childItem.ORGANIZATION}}</div>
                        <div class="item2 line">{{childItem.PER}}</div>
                        <div class="item2 back">{{childItem.BEPAYSUM}}</div>
                        <div class="item3 back">{{childItem.PAYSUM}}</div>
                        <div class="item2 back">
                          <div class="jx">
                          {{childItem.JXSALARY}}<i v-if="childItem.JXSALARY == '0.00'" class="star">*</i>
                          </div>
                        </div>
                        <div class="item2 back">{{childItem.avg}}</div>
                      </li>
                      <li>
                        <div class="item">合计</div>
                        <div class="item2 line">{{item.plateMap.per}}</div>
                        <div class="item2 back">{{item.plateMap.bePaySum}}</div>
                        <div class="item3 back">{{item.plateMap.paySum}}</div>
                        <div class="item2 back">{{item.plateMap.jxSum}}</div>
                        <div class="item2 back">{{item.plateMap.avg}}</div>
                      </li>
                    </ul>
                    <div class="empty" v-else>
                        本报表生成时，{{item.plate}}暂未发放薪资
                      </div>
                  </div>
                </div>
                <div>
                  <ul class="exp">
                    <li>*如意通绩效奖一年分年中、年末两次发放；</li>
                    <li>*园林、优居、置业板块公司绩效奖一年一次，年末发放；</li>
                    <li>*医药物流绩效并入基本工资发放，无绩效奖；</li>
                  </ul>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import api from "@/axios/api";
import { Toast } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
        immediate: true,
        handler: function(val) {
            if (val) {
                this.getSalartAndFormation(this.reportDate);
            }
        }
    }
  },
  data() {
    return {
      active: 0,
      thisMonth: "",
      lastMonth: "",
      orgMap: {},
      salary: false,
      xyDetail: [],
      activeNames: [0],
      reportDate: this.$route.query.reportDate,
      show:false,
      minDate: new Date(2021, 0),
      maxDate: "",
      currentDate: "",
    };
  },
  filters: {},
  mounted() {
     //this.getSalartAndFormation(this.reportDate);
  },
  methods: {
    getSalartAndFormation(time) {
      let par = {
        reportDate: time
      };
      api.getSalartAndFormation(par).then(res => {
        this.orgMap = res.orgMap;
        this.thisMonth = res.thisMonth;
        let mon = new Date().getMonth() - 1;
        if( mon < 0){
          this.maxDate = new Date(new Date().getFullYear() - 1, 11)
        }else{
          this.maxDate = new Date(new Date().getFullYear(), mon)
        }
        
        this.lastMonth = res.lastMonth;
        this.salary = res.salary;
        this.xyDetail = res.xyDetail;
        this.salary.detail.map((item, index) => {
          switch (item.plate) {
            case "集团公司":
              this.$set(item, "sort", 1);
              break;
            case "澳洋投控":
              this.$set(item, "sort", 2);
              break;
            case "澳洋健康":
              this.$set(item, "sort", 3);
              break;
            case "澳洋纺织":
              this.$set(item, "sort", 4);
              break;
            case "澳洋生态":
              this.$set(item, "sort", 5);
              break;
            case "康养板块":
              this.$set(item, "sort", 6);
              break;
          }
          item.detail.sort(function(a, b) {
            return a.SERIAL_NUMBER - b.SERIAL_NUMBER;
          });
        });
        this.xyDetail.map((item, index) => {
          let name = "chart_" + index;
          this.$set(item, "isdetail", true);
          this.$set(item, "idname", name);

          switch (item.plate) {
            case "集团公司":
              this.$set(item, "sort", 1);
              break;
            case "澳洋投控":
              this.$set(item, "sort", 2);
              break;
            case "澳洋健康":
              this.$set(item, "sort", 3);
              break;
            case "澳洋纺织":
              this.$set(item, "sort", 4);
              break;
            case "澳洋生态":
              this.$set(item, "sort", 5);
              break;
            case "康养板块":
              this.$set(item, "sort", 6);
              break;
          }
          item.detail.sort(function(a, b) {
            return a.SERIAL_NUMBER - b.SERIAL_NUMBER;
          });
        });
        this.salary.detail.sort(function(a, b) {
          return a.sort - b.sort;
        });
        this.xyDetail.sort(function(a, b) {
          return a.sort - b.sort;
        });
      });
    },
    drawChart(id, xlist, ylist) {
      let entryList = [];
      let leaveList = [];
      let nowList = [];
      ylist.map((item, index) => {
        entryList.push(item.entrySum);
        leaveList.push(item.leaveSum);
        nowList.push(item.nowAmoutSum);
      });
      // 基于准备好的dom，初始化echarts实例
      let chart_1 = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      chart_1.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["在职人数", "入职人数", "离职人数"],
          textStyle: {
            //图例的公用文本样式。
            fontSize: 12,
            color: "#8E8E8E"
          }
        },
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 30
        },
        xAxis: {
          type: "category",
          data: xlist
        },
        yAxis: [
          {
            type: "value",
            name: "人数：个           ",
            splitNumber: 4
          },
          {
            type: "value",

            splitNumber: 4,
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: "在职人数",
            type: "bar",
            emphasis: {
              focus: "series"
            },
            itemStyle: {
              normal: {
                color: "#477AFF"
              }
            },
            barWidth: 15, //  控制柱子的宽度
            data: nowList
          },
          {
            name: "入职人数",
            type: "bar",
            stack: "人数",
            emphasis: {
              focus: "series"
            },
            itemStyle: {
              normal: {
                color: "#31C131"
              }
            },
            yAxisIndex: 1,
            barWidth: 15, //  控制柱子的宽度
            data: entryList
          },
          {
            name: "离职人数",
            type: "bar",
            stack: "人数",
            emphasis: {
              focus: "series"
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#E12F2F"
              }
            },
            barWidth: 15, //  控制柱子的宽度
            data: leaveList
          }
        ]
      });
    },
    isChart(index) {
      this.xyDetail[index].isdetail = !this.xyDetail[index].isdetail;
      this.$nextTick(function() {
        this.drawChart(
          this.xyDetail[index].idname,
          this.xyDetail[index].y,
          this.xyDetail[index].x
        );
      });
    },
     add(num) {
            if (num < 10) return "0" + "" + num;
            else return num;
        },
    onConfirm(picker, value, index) {
            this.show = false;
            let year = this.currentDate.getFullYear();
            let month = this.currentDate.getMonth() + 1;
            this.reportDate = year + "-" + this.add(month);
            this.getSalartAndFormation(this.reportDate);
        },
        onCancel() {
            this.show = false;
        },
        lf(){
            let date = this.reportDate;
            var arr = date.split('-');
            var year = arr[0]; //获取当前日期的年份
            var month = arr[1]; //获取当前日期的月份
            var year2 = year;
            var month2 = parseInt(month) - 1;
            if (month2 == 0) {
                year2 = parseInt(year2) - 1;
                month2 = 12;
            }
            
            var mdate = new Date(year2, this.add(month2)) - this.minDate;
            if(mdate > 0){
              this.reportDate = year2 + '-' + this.add(month2) ;
              this.getSalartAndFormation(this.reportDate);
            }else{
              Toast.fail("无法选择更早的时间");
            }
        },
        rg(){
            let date = this.reportDate;
            var arr = date.split('-');
            var year = arr[0]; //获取当前日期的年份
            var month = arr[1]; //获取当前日期的月份
            var year2 = year;
            var month2 = parseInt(month) + 1;
            if (month2 == 13) {
                year2 = parseInt(year2) + 1;
                month2 = 1;
            }
            var mdate = new Date(year2, this.add(month2)) - new Date(new Date().getFullYear(), new Date().getMonth() );
           
            
            if(mdate <= 0){
              this.reportDate = year2 + '-' + this.add(month2) ;
              this.getSalartAndFormation(this.reportDate);
            }else{
              Toast.fail("无法选择更晚的时间");
            }
            
        }
  }
};
</script>

<style lang="less" scoped>
.pro-report {
  .u-time{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4vw;
    color: #477aff;
    background: #fff;
    .date{
      margin: 0 8vw;
    }
  }
  /deep/.van-tab--active {
    color: #477aff;
    font-weight: 700;
  }
  /deep/.van-tabs__line {
    background-color: #477aff;
  }

  .detail {
    display: flex;
    margin-top: 2.6vw;
    padding: 7vw 0 5.3vw 0;
    background: #fff;
    li {
      position: relative;
      flex: 1;
      .num {
        font-size: 16px;
        font-weight: 700;
        color: #282828;
      }
      .name {
        margin-top: 2vw;
        font-size: 14px;
        color: #888;
      }
      .line {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1px;
        height: 8.6vw;
        background: #c1c1c1;
      }
    }
  }
  // /deep/.van-collapse {
  //   /deep/.van-cell{
  //     align-items: center;
  //     padding: 3.6vw 3.2vw;
  //     background: #e2eafe;
  //   }
  //   /deep/.van-collapse-item__content {
  //     padding: 0;
  //   }
  // }
  .u-card {
    .hd {
      display: flex;
      justify-content: space-between;
      padding: 3.6vw 3.2vw;
      background: #e2eafe;
      line-height: 1;
      font-size: 14px;
      .name {
        font-weight: 700;
        font-size: 16px;
      }
    }
    .list {
      background: #fff;
      li {
        display: flex;
        font-size: 14px;
        text-align: center;
        .item {
          width: 22%;
          padding: 2.4vw 0;
        }
        .item2 {
          width: 16.5%;
          padding: 2.4vw 0;
          .jx {
            position: relative;
            .star {
              position: absolute;
              top: -6px;
              right: 8px;
              font-size: 18px;
              z-index: 9;
            }
          }
        }
        .item3 {
          width: 12%;
          padding: 2.4vw 0;
          .jx {
            position: relative;
            .star {
              position: absolute;
              top: -6px;
              right: 17px;
              font-size: 18px;
              z-index: 9;
            }
          }
        }
        .line {
          border-left: 1px solid #e0dfdf;
          border-right: 1px solid #e0dfdf;
        }
        .back {
          background: #fafafa;
        }
      }
      li:first-child {
        color: #477aff;
      }
    }
    .chart {
      padding: 2vw 0;
      background: #fff;
    }
    .empty {
      padding: 4vw 0;
      background: #fff;
      color: #c5c5c5;
      font-size: 14px;
    }
  }
  .u-card2 {
    .hd {
      .isdetail {
        font-size: 14px;
        color: #477aff;
        .f-dfa {
          display: flex;
          align-items: center;
        }
        i {
          display: inline-block;
          margin-right: 4px;
        }
        .qs {
          width: 5.6vw;
          height: 2.6vw;
          background: url(../assets/rlzy/qs.png) no-repeat;
          background-size: 100% 100%;
        }
        .mx {
          width: 4vw;
          height: 4vw;
          background: url(../assets/rlzy/mx.png) no-repeat;
          background-size: 100% 100%;
        }
      }
      .exp {
        margin-left: 2vw;
        font-size: 14px;
        font-weight: 400;
        color: #c2c2c2;
      }
    }
    .list {
      li {
        font-size: 14px;
        .item {
          width: 24%;
          padding: 2.4vw 0;
        }
        .item2 {
          width: 16%;
          padding: 2.4vw 0;
        }
        .item3 {
          width: 15%;
          padding: 2.4vw 0;
        }
      }
    }
  }
  .exp {
    padding: 4vw;
    font-size: 16px;
    text-align: left;
    background: #fff;
    li {
      padding-bottom: 1vw;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/rlzy/hrm.vue